import { initSubRoutes } from '../../../../utils/router';

const RoutesSignalerArmePerdueVolee = initSubRoutes({
    route: '/signaler-perte-vol',
    subroutes: {},
    nom: 'Signaler une arme perdue/volee',
});

export default RoutesSignalerArmePerdueVolee;
